(function () {
  var intro = document.querySelector('.collection-seo-intro');
  if (!intro) return;

  var pathParts = window.location.pathname.split('/');
  if (pathParts[1] !== 'collections' || !pathParts[2]) return;
  var handle = pathParts[2];
  var baseUrl = '/collections/' + handle;
  var activeTag = pathParts[3] || '';

  var style = document.createElement('style');
  style.textContent = '.crop-chips{padding:8px 0 4px;display:flex;flex-direction:column;gap:6px}.crop-chips__row{display:flex;align-items:center;gap:8px;overflow:hidden}.crop-chips__label{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;white-space:nowrap;flex-shrink:0;width:32px}.crop-chips__rail{display:flex;gap:5px;overflow-x:auto;padding-bottom:1px;flex:1;scrollbar-width:none}.crop-chips__rail::-webkit-scrollbar{display:none}.crop-chips__chip{display:inline-flex;align-items:center;padding:3px 11px;border:1.5px solid rgba(var(--color-foreground),.2);border-radius:100px;font-size:12px;line-height:1.5;color:rgba(var(--color-foreground),.6);text-decoration:none;white-space:nowrap;flex-shrink:0;transition:background .15s,color .15s,border-color .15s}.crop-chips__chip--active{background:rgb(var(--color-foreground));border-color:rgb(var(--color-foreground));color:rgb(var(--color-background));font-weight:600}';
  document.head.appendChild(style);

  fetch('/collections/' + handle + '/products.json?limit=250&fields=tags')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var crops = {}, problems = {};
      data.products.forEach(function (p) {
        (p.tags || []).forEach(function (t) {
          if (t.indexOf('crop-') === 0) crops[t] = 1;
          if (t.indexOf('problem-') === 0) problems[t] = 1;
        });
      });

      var ct = Object.keys(crops).sort();
      var pt = Object.keys(problems).sort();
      if (!ct.length && !pt.length) return;

      var wrapper = document.createElement('div');
      if (ct.length) wrapper.insertAdjacentHTML('beforeend', rail('Crop', ct, 'crop-', baseUrl, activeTag));
      if (pt.length) wrapper.insertAdjacentHTML('beforeend', rail('Pest', pt, 'problem-', baseUrl, activeTag));

      var existing = intro.querySelector('#fk-tag-chips');
      if (existing) {
        existing.replaceWith(wrapper);
      } else {
        intro.appendChild(wrapper);
      }
    })
    .catch(function () {});

  function rail(label, tags, prefix, base, active) {
    var anyActive = active && tags.indexOf(active) >= 0;
    var chips = '<a href="' + base + '" class="crop-chips__chip' + (anyActive ? '' : ' crop-chips__chip--active') + '">All</a>';
    tags.forEach(function (tag) {
      var name = tag.slice(prefix.length).split('-').map(function (w) {
        return w.charAt(0).toUpperCase() + w.slice(1);
      }).join(' ');
      var isActive = tag === active;
      chips += '<a href="' + (isActive ? base : base + '/' + tag) + '" class="crop-chips__chip' + (isActive ? ' crop-chips__chip--active' : '') + '">' + name + '</a>';
    });
    return '<div class="crop-chips"><div class="crop-chips__row"><span class="crop-chips__label">' + label + '</span><div class="crop-chips__rail">' + chips + '</div></div></div>';
  }
})();
